export const CREATE_VITAL = 'CREATE_VITAL';
export const SET_VITALS = 'SET_VITALS';
export const CREATE_USER = 'CREATE_USER';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
